export default "__VITE_ASSET__BJyyXNxy__"